import * as React from 'react';
import { SVGProps } from 'react';

const IconEraseSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.154 21a1 1 0 0 1-.707-.293l-3.869-3.869c-.77-.77-.77-2.02 0-2.791L13.047 3.578c.77-.77 2.02-.77 2.791 0l5.584 5.583c.77.771.77 2.021 0 2.792L14.375 19H22v2H7.154Zm.555-9.255 5.546 5.546L11.546 19H7.569l-3.557-3.557 3.698-3.698Z"
    />
  </svg>
);
export default IconEraseSizeM;
